import React from 'react';
import { useAuth } from '../context/AuthContext';
import { isWorkshopV2 } from './nav';

/**
 * Route switch for the workshop v2 pages: a WORKSHOP login whose workshop has «الواجهة الجديدة للورشة»
 * (user.workshopUiV2) gets `v2`; everyone else — admins, agents, suppliers, and workshops with the switch off —
 * gets `legacy`, the page they have today, unchanged. Both are lazy components (App.tsx), so the v2 chunks are never
 * downloaded by anyone who does not use them.
 *
 *   <Route path="/" element={<PrivateRoute><WorkshopGate v2={WorkshopHome} legacy={Dashboard} /></PrivateRoute>} />
 */
export interface WorkshopGateProps {
  v2: React.ElementType;
  legacy: React.ElementType;
}

const WorkshopGate: React.FC<WorkshopGateProps> = ({ v2: V2, legacy: Legacy }) => {
  const { user } = useAuth();
  return isWorkshopV2(user) ? <V2 /> : <Legacy />;
};

export default WorkshopGate;
